import React from 'react';
import ReactDOM from 'react-dom';
import {UserSetFormTreeChangedStore} from '../stores/UserSetStores';
import UserSetActions from '../actions/UserSetActions';
import FormItemUtil from '../utils/FormItemUtil';

export default class UserSetFormPropertyPanel extends React.Component
{
	constructor(props, context)
	{
    	super(props, context);
    	this.state={};
		this.allUserProperties = this.props.allUserProperties?this.props.allUserProperties:{};
		
		//this.allUserProperties["50023"] = {displayLength:50};

    	this.unscribeUserSetFormTreeChangedStore = UserSetFormTreeChangedStore.listen(this.onUserSetFormTreeChanged.bind(this));    	
    }

    onUserSetFormTreeChanged(properties)
    {
    	if(!this.allUserProperties.hasOwnProperty(properties.innerId))
		{
			this.allUserProperties[properties.innerId] = {};
		}
		this.userProperties = this.allUserProperties[properties.innerId];
    	this.setState(properties);
    }

    componentWillUnmount()
    {
    	this.unscribeUserSetFormTreeChangedStore();
    }

    componentDidMount()
    {
    	$(this.propertyPanel).find(".minimal").iCheck({
	      checkboxClass: 'icheckbox_minimal-blue14',width:'18px',height:'18px'
	    });
	    $(this.layoutNode).selectpicker({width:'100px',height:'24px',noneSelectedText: '未选中',container:'body',
    										noneResultsText: '没有找到匹配项'});

	    $(this.visibleNode).on('ifClicked',this.visibleNodeClick.bind(this));
	    $(this.hideInVisibleNode).on('ifClicked',this.hideInVisibleNodeClick.bind(this));
	    $(this.allowEditNode).on('ifClicked',this.allowEditNodeClick.bind(this));
	    $(this.skipTabNode).on('ifClicked',this.skipTabNodeClick.bind(this));
    }

    componentDidUpdate()
    {
		let allColWidth =this.props.allColWidth?this.props.allColWidth:{};
    	let stateObj = Object.assign(this.state,this.userProperties);
    	if(stateObj.visible == true)$(this.visibleNode).iCheck('check');else $(this.visibleNode).iCheck('uncheck');
		if(stateObj.allowEdit == true)$(this.allowEditNode).iCheck('check');else $(this.allowEditNode).iCheck('uncheck');
		if(stateObj.hideInVisible == true)$(this.hideInVisibleNode).iCheck('check');else $(this.hideInVisibleNode).iCheck('uncheck');
		if(stateObj.skipTab == true)$(this.skipTabNode).iCheck('check');else $(this.skipTabNode).iCheck('uncheck');
		$(this.layoutNode).selectpicker('val',stateObj.layout);

		//TODO 更新enable
		$(this.labelNode).val(stateObj.label);
		if(stateObj.labelEnabled == false)
			$(this.labelNode).attr("disabled",true);
		else
			$(this.labelNode).removeAttr("disabled");

		if(stateObj.visibleEnabled == false)
		{
			$(this.visibleNode).attr("disabled",true);
			$(this.visibleContainer).find(".icheckbox_minimal-blue14").addClass("disabled");
			$(this.visibleDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.visibleNode).removeAttr("disabled");
			$(this.visibleContainer).find(".icheckbox_minimal-blue14").removeClass("disabled");
			$(this.visibleDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}

		if(stateObj.hideInVisibleEnabled == false)
		{
			$(this.hideInVisibleNode).attr("disabled",true);
			$(this.hideInVisibleContainer).find(".icheckbox_minimal-blue14").addClass("disabled");
			$(this.hideInVisibleDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.hideInVisibleNode).removeAttr("disabled");
			$(this.hideInVisibleContainer).find(".icheckbox_minimal-blue14").removeClass("disabled");
			$(this.hideInVisibleDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}

		if(stateObj.allowEditEnabled == false)
		{
			$(this.allowEditNode).attr("disabled",true);
			$(this.allowEditContainer).find(".icheckbox_minimal-blue14").addClass("disabled");
			$(this.allowEditDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.allowEditNode).removeAttr("disabled");
			$(this.allowEditContainer).find(".icheckbox_minimal-blue14").removeClass("disabled");
			$(this.allowEditDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}

		if(stateObj.skipTabEnabled == false)
		{
			$(this.skipTabNode).attr("disabled",true);
			$(this.skipTabDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.skipTabNode).removeAttr("disabled");
			$(this.skipTabDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}

		if(stateObj.layoutEnabled == false)
		{
			$(this.layoutNode).attr("disabled",true);
			$(this.layoutDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.layoutNode).removeAttr("disabled");
			$(this.layoutDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}

		$(this.displayLengthNode).val(stateObj.displayLength);
		if(stateObj.displayLengthEnabled == false)
		{
			$(this.displayLengthNode).attr("disabled",true);
			$(this.displayLengthDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.displayLengthNode).removeAttr("disabled");
			$(this.displayLengthDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}
		$(this.shortCutNode).val(stateObj.shortCut);
		if(stateObj.shortCutEnabled == false)
		{
			$(this.shortCutNode).attr("disabled",true);
			$(this.shortCutDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.shortCutNode).removeAttr("disabled");
			$(this.shortCutDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}
		$(this.lockColumnNode).val(stateObj.lockedNum);
		if(stateObj.lockedNumEnabled == false)
		{
			$(this.lockColumnNode).attr("disabled",true);
			$(this.lockedNumDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.lockColumnNode).removeAttr("disabled");
			$(this.lockedNumDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}
		if(allColWidth[this.state.innerId]){
			stateObj.width = allColWidth[this.state.innerId].width;
		}
		$(this.widthNode).val(stateObj.width);
		if(stateObj.widthEnabled == false)
		{
			$(this.widthNode).attr("disabled",true);
			$(this.widthDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.widthNode).removeAttr("disabled");
			$(this.widthDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}
		$(this.heightNode).val(stateObj.height);
		if(stateObj.heightEnabled == false)
		{
			$(this.heightNode).attr("disabled",true);
			$(this.heightDefaultNode).css("pointer-events","none").css("color","#d4d4e6");
		}
		else
		{
			$(this.heightNode).removeAttr("disabled");
			$(this.heightDefaultNode).css("pointer-events","auto").css("color","#0178D4");
		}
		
    }

    visibleNodeClick()
    {
    	if($(this.visibleNode).is(":checked"))
    		{this.userProperties.visible = false;}
    	else
    		{this.userProperties.visible = true;}
    }

    allowEditNodeClick()
    {
    	if($(this.allowEditNode).is(":checked"))
    		{this.userProperties.allowEdit = false;}
    	else
    		{this.userProperties.allowEdit = true;}
    }

    skipTabNodeClick()
    {
    	if($(this.skipTabNode).is(":checked"))
    		{this.userProperties.skipTab = false;}
    	else
    		{this.userProperties.skipTab = true;}
    }

    hideInVisibleNodeClick()
    {
    	if($(this.hideInVisibleNode).is(":checked"))
    		{this.userProperties.hideInVisible = false;}
    	else
    		{this.userProperties.hideInVisible = true;}
    }

    labelInputBlur()
    {
    	this.userProperties.label = $(this.labelNode).val();
    	UserSetActions.treeLabelChanged(this.userProperties.label);
    }

    displayLengthInputBlur()
    {
    	this.userProperties.displayLength = $(this.displayLengthNode).val();
    }

    shortCutInputBlur()
    {
    	this.userProperties.shortCut = $(this.shortCutNode).val();
    }

    layoutChanged()
    {
    	this.userProperties.layout = $(this.layoutNode).val();
    }

    lockedInputBlur()
    {
    	this.userProperties.lockedNum = $(this.lockColumnNode).val();
    }

    widthInputBlur()
    {
    	this.userProperties.width = $(this.widthNode).val();
    }

    heightInputBlur()
    {
    	this.userProperties.height = $(this.heightNode).val();
    }

    deleteUserProperty(propertyName)
    {
    	var _parentWindow = window.parent.window;
		if(_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.state.innerId];
			if(_properties && _properties.hasOwnProperty(propertyName))
				delete _properties[propertyName];
		}
    }

    setVisibleDefault()
    {
    	this.deleteUserProperty("visible");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_Visible_Final();
		if(propertyValue)$(this.visibleNode).iCheck('check');else $(this.visibleNode).iCheck('uncheck');
    }

    setHideInVisibleDefault()
    {
    	this.deleteUserProperty("hideInVisible");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_HideInVisible();
		if(propertyValue)$(this.hideInVisibleNode).iCheck('check');else $(this.hideInVisibleNode).iCheck('uncheck');
    }

    setAllowEditDefault()
    {
    	this.deleteUserProperty("allowEdit");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_AllowEdit_Final();
		if(propertyValue)$(this.allowEditNode).iCheck('check');else $(this.allowEditNode).iCheck('uncheck');
    }

    setSkipTabDefault()
    {
    	this.deleteUserProperty("skipTab");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_SkipTab();
		if(propertyValue)$(this.skipTabNode).iCheck('check');else $(this.skipTabNode).iCheck('uncheck');
    }

    setLayoutDefault()
    {
    	this.deleteUserProperty("layout");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_Layout();
		$(this.layoutNode).selectpicker('val',propertyValue);
		
    }

    setDisplayLengthDefault()
    {
    	this.deleteUserProperty("displayLength");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_DisplayLength();
		$(this.displayLengthNode).val(propertyValue);
    }

    setShortCutDefault()
    {
    	this.deleteUserProperty("shortCut");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_ShortCut();
		$(this.shortCutNode).val(propertyValue);
    }

    setLockedNumDefault()
    {
    	this.deleteUserProperty("lockedNum");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_LockedNum();
		$(this.lockColumnNode).val(propertyValue);
    }

    setWidthDefault()
    {
    	this.deleteUserProperty("width");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_Width();
		$(this.widthNode).val(propertyValue);
    }

    setHeightDefault()
    {
    	this.deleteUserProperty("height");
    	let key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,this.state.innerId);
		let itemControl = FormItemUtil.getFormItemControl(key,false);
		let propertyValue = itemControl.getProperty_Height();
		$(this.heightNode).val(propertyValue);
    }

    render()
    {
    	return (<div className="box box-info" style={{flexGrow:0,boxShadow:'none',border:'none',width:'auto',marginBottom:'2px'}}>
		    		<div className="box-header with-border" style={{marginBottom:'5px',marginTop:'17px',paddingRight:'30px',paddingLeft:'30px',marginLeft:'113px',fontFamily:'STSongti-SC-Regular',fontSize:'16px',color:'#000000'}}>
		    			<h4 className="box-title" style={{fontSize:'15px',paddingRight:'30px',fontFamily:'STSongti-SC-Regular',fontSize:'16px',color:'#000000',fontWeight:'normal'}}>属性设置</h4>
		    		</div>
		    		<form style={{padding:'5px'}} ref={node => this.propertyPanel = node}>
		    			<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>标签</label>
			    			<input ref={node=>this.labelNode = node} onChange={this.labelInputBlur.bind(this)} type="text" spellcheck="false" className="form-control" style={{padding:'2px',height:'24px',fontSize:'12px',width:'139px'}} defaultValue={this.state.label}></input>
			    		</div>
			    		<div ref={node => this.visibleContainer = node} style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>可见</label>
			    			<input ref={node => this.visibleNode = node} type="checkbox" className="minimal"/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setVisibleDefault.bind(this)} ref={node=>this.visibleDefaultNode=node}>采用默认</div>
			    		</div>
			    		<div ref={node => this.hideInVisibleContainer = node} style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>不可见时隐藏</label>
			    			<input ref={node => this.hideInVisibleNode = node} type="checkbox" className="minimal"/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setHideInVisibleDefault.bind(this)} ref={node=>this.hideInVisibleDefaultNode=node}>采用默认</div>
			    		</div>
			    		<div ref={node => this.allowEditContainer = node} style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>编辑</label>
			    			<input ref={node => this.allowEditNode = node} type="checkbox" className="minimal"/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setAllowEditDefault.bind(this)} ref={node=>this.allowEditDefaultNode=node}>采用默认</div>
			    		</div>
			    		<div ref={node => this.skipTabContainer = node} style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>跳过Tab</label>
			    			<input ref={node => this.skipTabNode = node} type="checkbox" className="minimal"/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setSkipTabDefault.bind(this)} ref={node=>this.skipTabDefaultNode=node}>采用默认</div>
			    		</div>

			    		<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>布局方式</label>
			    			<select className="selectpicker form-control" data-live-search="true" ref={ node => this.layoutNode = node } style={{padding:'2px !important',height:'24px'}} onChange={this.layoutChanged.bind(this)}>
				                <option value='horizontal'>横向</option><option value='vertical'>纵向</option>
				            </select>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setLayoutDefault.bind(this)} ref={node=>this.layoutDefaultNode=node}>采用默认</div>
			    		</div>
			    		
			    		<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>字符长度</label>
			    			<input defaultValue={this.state.displayLength} ref={node => this.displayLengthNode = node} type="text" 
			    					spellcheck="false" className="form-control" style={{padding:'2px',height:'24px',fontSize:'12px',width:'139px'}}
			    					onChange={this.displayLengthInputBlur.bind(this)}/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setDisplayLengthDefault.bind(this)} ref={node=>this.displayLengthDefaultNode=node}>采用默认</div>
			    		</div>

			    		<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>快捷键</label>
			    			<input defaultValue={this.state.shortCut} ref={node => this.shortCutNode = node} type="text" spellcheck="false" 
			    				   className="form-control" style={{padding:'2px',height:'24px',fontSize:'12px',width:'139px'}}
			    				   onChange={this.shortCutInputBlur.bind(this)}/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setShortCutDefault.bind(this)} ref={node=>this.shortCutDefaultNode=node}>采用默认</div>
			    		</div>

			    		<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>锁定列数</label>
			    			<input defaultValue={this.state.lockedNum} ref={node => this.lockColumnNode = node} type="text" spellcheck="false" 
			    				   className="form-control" style={{padding:'2px',height:'24px',fontSize:'12px',width:'139px'}}
			    				   onChange={this.lockedInputBlur.bind(this)}/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setLockedNumDefault.bind(this)} ref={node=>this.lockedNumDefaultNode=node}>采用默认</div>
			    		</div>

			    		<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>宽度</label>
			    			<input defaultValue={this.state.width} ref={node => this.widthNode = node} type="text" spellcheck="false" className="form-control" style={{padding:'2px',height:'24px',fontSize:'12px',width:'139px'}}
			    				   onChange={this.widthInputBlur.bind(this)}/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setWidthDefault.bind(this)} ref={node=>this.widthDefaultNode=node}>采用默认</div>
			    		</div>

			    		<div style={{display:'flex',flexDirection:'row',alignItems:'center',fontSize:'12px',marginBottom:'11px'}}>
			    			<label style={{fontWeight:'normal',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingLeft:'5px',width:'100px',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px',marginRight:'10px'}}>高度</label>
			    			<input defaultValue={this.state.height} ref={node => this.heightNode = node} type="text" spellcheck="false" className="form-control" style={{padding:'2px',height:'24px',fontSize:'12px',width:'139px'}}
			    				   onChange={this.heightInputBlur.bind(this)}/>
			    			<div style={{textDecoration:'underline',marginLeft:'10px',cursor:'pointer',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#4A90E2'}} onClick={this.setHeightDefault.bind(this)} ref={node=>this.heightDefaultNode=node}>采用默认</div>
			    		</div>
			    	</form>
			    </div>);
    	


    }
}


// WEBPACK FOOTER //
// ./src/userformset/UserSetFormPropertyPanel.js